import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lib-indemity',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './indemity.component.html',
  styleUrl: './indemity.component.css',
})
export class IndemityComponent {}
